import {globalStore} from '../../main.js'

export default {
  name: 'createPassword',
  data() {
    return {
      formSubmitted: false,
      success: false,
      isExpired: false,
      forbidden: false,
      failed: false,
      redirectEmail: false,
      credentials: {
        UserName: null,
        culture: globalStore.culture.locale,
        backUrl: ''
      }
    }
  },
  created: function(){
    this.credentials.backUrl = this.$route.query.backurl;
    this.isExpired = this.$route.name == 'linkExpired';
    this.redirectEmail = Boolean(this.$route.query.redirectEmail) && /^true$/.test(this.$route.query.redirectEmail);
    document.title = this.isExpired ? this.labels.HEADING_EXPIRED : this.labels.HEADING;
  },
  beforeDestroy: function(){
    document.title = globalStore.defaultTitle;
  },
  methods: {
    proceed: function(event) {
      event.preventDefault();
      this.formSubmitted = true;
      this.forbidden = false;
      this.failed = false;

      if (this.formValid) {
        this.$axios.post(globalStore.host + 'ForgotPassword?redirectEmail=' + this.redirectEmail, this.credentials)
          .then(response => {
              this.success = true;
          })
          .catch(err => {
            if (err.response && err.response.status === 403) {
              this.forbidden = true;
            } else {
              this.failed = true;
            }
          });
      }
    },
    cancel: function(event) {
      event.preventDefault();
      this.$router.push('dashboard');
    }
  },
  computed: {
    loginFilled: function() {
      return !!this.credentials.UserName;
    },
    loginValid: function() {
      return !globalStore.emailInBlackList(this.credentials.UserName);
    },
    isEmail: function() {
      if (!!this.credentials.UserName) {
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return reg.test(this.credentials.UserName);
      }
    },
    formValid: function() {
      return this.formSubmitted && this.loginFilled && this.loginValid && this.isEmail;
    },
    labels: function() {
        return globalStore.culture.strings.ForgotPassword;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js